import { render } from "./EntityInformation.vue?vue&type=template&id=a79dd324"
import script from "./EntityInformation.vue?vue&type=script&lang=js"
export * from "./EntityInformation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__